module.exports = __webpack_public_path__ + "static/media/ai_edit.61ad930e.svg";